import { WebInstantwinCustomLayoutSectionMedia, WebInstantwinCustomLayoutSectionRule } from '@/typings/campaigns'

export type WebInstantwinCustomSection = WebInstantwinCustomLayoutSectionMedia | WebInstantwinCustomLayoutSectionRule

export const WEB_INSTANTWIN_DEFAULT_MEDIA_SIZE = 800

export const createMediaSection = (stepOrder: number): WebInstantwinCustomLayoutSectionMedia => ({
  mode: 'media',
  step_order: stepOrder,
  pc_media_name: null,
  pc_media_url: null,
  pc_media_size: WEB_INSTANTWIN_DEFAULT_MEDIA_SIZE,
  sp_media_name: null,
  sp_media_url: null,
  url: null,
  background_color: null
})

export const normalizeSectionOrder = (sections: WebInstantwinCustomSection[]): WebInstantwinCustomSection[] =>
  sections.map((section, index) => ({
    ...section,
    step_order: index + 1
  }))

export const getInitiallyExpandedMediaIndexes = (sections: WebInstantwinCustomSection[]): number[] => {
  const mediaIndexes = sections
    .map((section, index) => ({ section, index }))
    .filter(item => item.section.mode === 'media')
    .map(item => item.index)

  return mediaIndexes.length > 1 ? [] : mediaIndexes
}

export const appendMediaSection = (sections: WebInstantwinCustomSection[]): WebInstantwinCustomSection[] => {
  const nextStepOrder = sections.length ? Math.max(...sections.map(section => section.step_order)) + 1 : 1
  const newSection = createMediaSection(nextStepOrder)
  return normalizeSectionOrder([...sections, newSection])
}

export const removeSectionAt = (
  sections: WebInstantwinCustomSection[],
  index: number
): WebInstantwinCustomSection[] => {
  const next = sections.filter((_, currentIndex) => currentIndex !== index)
  return normalizeSectionOrder(next)
}

export const moveSection = (
  sections: WebInstantwinCustomSection[],
  fromIndex: number,
  toIndex: number
): WebInstantwinCustomSection[] => {
  if (fromIndex === toIndex) {
    return normalizeSectionOrder([...sections])
  }

  const next = [...sections]
  const [moved] = next.splice(fromIndex, 1)
  next.splice(toIndex, 0, moved)
  return normalizeSectionOrder(next)
}
